import { isUser } from '../../../../React/components/Global/LazyLoader';

/* eslint-disable */
function loadFrontCookies() {
	'use strict';
	if (!isUser) {
		return;
	}
	if (!window.eap_cookies_data || typeof window.eap_cookies_data === 'undefined') {
		return;
	}

	var $ = window.$ || window.jQuery;

	$(document).ready(function() {
		var EAPCookie = EAPCookie || {};
		window.EAPCookie = EAPCookie;
		EAPCookie.options = {};

		EAPCookie.options.location = location.href;
		EAPCookie.options.serverId = eap_cookies_data.serverId;
		EAPCookie.options.server = eap_cookies_data.server;
		EAPCookie.options.url = eap_cookies_data.url;
		EAPCookie.options.syncRemoteinterval = 10000;
		EAPCookie.options.userId = false;
		EAPCookie.options.geoLoc = {};

		EAPCookie.newActions = [];
		EAPCookie.sendActions = [];

		EAPCookie.Action = function(eventType, eventName, eventKey) {
			eventType = typeof eventType === 'undefined' ? 'undefined' : eventType;
			eventName = typeof eventName === 'undefined' ? 'undefined' : eventName;
			eventKey = typeof eventKey === 'undefined' ? '' : eventKey;

			this.time = new Date().getTime();
			this.name = eventName;
			this.type = eventType;
			this.page = location.href;
			this.pagename = EAPCookie.options.pagename = $(document)
				.find('title')
				.text();
			this.key = eventKey;
			EAPCookie.newActions.push(this);
			EAPCookie.syncLocal2Cookies();
		};

		EAPCookie.generateKey = function() {
			var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
			var string_length = 20;
			var randomstring = '';
			for (var i = 0; i < string_length; i++) {
				var rnum = Math.floor(Math.random() * chars.length);
				randomstring += chars.substring(rnum, rnum + 1);
			}
			return randomstring;
		};

		EAPCookie.IsJsonString = function(str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}

			return true;
		};

		EAPCookie.makeRequest = function(data, beforeSendCallback, successCallback, errorCallback) {
			var emptyFunction = function(a, b) {};

			beforeSendCallback = typeof beforeSendCallback !== undefined ? emptyFunction : beforeSendCallback;
			successCallback = typeof successCallback !== undefined ? EAPCookie.handleSuccess : successCallback;
			errorCallback = typeof errorCallback !== undefined ? emptyFunction : errorCallback;

			$.ajax({
				url: 'https://cookies.easyagentpro.com/cookies-pusher/',
				method: 'POST',
				data: data,
				crossDomain: true,
				dataType: 'json',
				async: true,
				beforeSend: beforeSendCallback,
				success: successCallback,
				error: errorCallback,
			});
		};

		EAPCookie.handleSuccess = function(data) {
			// console.log('Cookie Sync OK', data);
			try {
				if (data.new_user === true && typeof data.user_id === 'number') {
					EAPCookie.options.userId = data.user_id;
					EAPCookie.options.sendActions = [];
				}

				EAPCookie.syncLocal2Cookies();
			} catch (e) {}
		};

		EAPCookie.handleSyncError = function() {
			EAPCookie.newActions = EAPCookie.sendActions.concat(EAPCookie.newActions);
		};

		EAPCookie.sync = function() {
			// console.log('sync');
			if (EAPCookie.newActions.length === 0) return false;

			EAPCookie.sendActions = EAPCookie.newActions.slice(0);
			EAPCookie.newActions = [];

			var data = {
				action: 'addRecord',
				options: JSON.stringify(EAPCookie.options),
				data: JSON.stringify(EAPCookie.sendActions),
			};

			EAPCookie.makeRequest(data, undefined, undefined, EAPCookie.handleSyncError);
		};

		EAPCookie.syncLocal2Cookies = function() {
			if (isNaN(EAPCookie.options.userId)) {
				EAPCookie.options.userId = false;
			}
			Cookies.set('userId', +EAPCookie.options.userId, {
				expires: 365,
				path: '/',
			});
			Cookies.set('actions', JSON.stringify(EAPCookie.newActions), {
				expires: 365,
				path: '/',
			});
			EAPCookie.sync();
		};

		EAPCookie.syncCookies2Local = function(cookieAction) {
			EAPCookie.newActions = cookieAction.concat(EAPCookie.newActions);
		};

		EAPCookie.geoInit = function() {
			var clientsGeoData = Cookies.get('geoData');
			// console.log(clientsGeoData);
			if (clientsGeoData === undefined) {
				//console.log('emptygeo');
				$.get(
					'//ipinfo.io',
					function(response) {
						if (response.ip !== undefined) {
							Cookies.set('geoData', response, {
								expires: 1,
								path: '/',
							});
						}
					},
					'jsonp'
				);
			} else {
				EAPCookie.options.geoLoc = clientsGeoData;
			}
		};

		EAPCookie.geoInit();

		var cookieId = +Cookies.get('userId');

		var cookieAction = typeof Cookies.get('actions') !== undefined ? [] : Cookies.get('actions');

		if (EAPCookie.IsJsonString(cookieAction) === true) {
			cookieAction = JSON.parse(undefined);
		}

		if (cookieId === false) {
			new EAPCookie.Action('new_user', 'User first seen');
		} else {
			EAPCookie.options.userId = cookieId;
		}

		if (Array.isArray(cookieAction) === true && cookieAction.length > 0) {
			EAPCookie.syncCookies2Local(cookieAction);
		}

		setInterval(function() {
			EAPCookie.sync();
		}, EAPCookie.options.syncRemoteinterval);

		if ($('body').hasClass('squeeze_template')) {
			new EAPCookie.Action('squeezepageload', 'Visited Squeeze Page');
		} else if ($('body').hasClass('eap-search__details')) {
			new EAPCookie.Action('pageload', 'IDX Listing Viewed');
		} else {
			new EAPCookie.Action('pageload', 'Page loaded');
		}
	});
}
export default loadFrontCookies;
